import React, {useRef} from 'react';
import { Grid } from '@material-ui/core';
import { Alert, AlertTitle } from '@material-ui/lab';//Necesita instalar:  npm install @material-ui/lab
import { ThemeProvider } from '@material-ui/core/styles';
import alertStyle from './AlertStyle';
import { customStyle } from './AlertStyle';
import { descripcionErrores } from '../../../AppData';
import HighlightOffIcon from '@material-ui/icons/HighlightOff';

/**
 * @function ComponenetAlert contiene los avisos que se mostrarán en la aplicaicón
 * @param {*} props 
 */
export default function ComponenetAlert(props) {

    function handleClick(param) {
        param.current.focus();
    }

    const claseAlert = customStyle().alertClass;
    const claseGrid = customStyle().alertGrid;
    const claseIcon = customStyle().iconClass;

    return (
        <Grid className={props.classes.classGridAlert}>
            <ThemeProvider theme={alertStyle}>
                <Alert
                    className={props.classes.classAlert}//Clase aplicada
                    icon={props.icon}//Icono que recibirá
                    severity={props.severity}//Inserta el color y el icono, dependiendo del valor recibido
                    variant={props.variant}//Tipo de borde (estilo)
                    color={props.color}//Color del componente
                >
                    <AlertTitle /*Texto del título*/>
                        {props.title}
                    </AlertTitle>
                    {//Se recibe un array con los textos
                        <Grid>
                            {props.msg.map((referencias, index) => (  
                                <Grid container className={claseGrid} direction="row">
                                    <HighlightOffIcon className={claseIcon}/>
                                    <p
                                        className={claseAlert}
                                        key={index.toString()}
                                        dangerouslySetInnerHTML={{ __html: "El campo <strong><a style=color:#B00020>" + descripcionErrores[referencias.current.id] + "</a></strong> no está debidamente cumplimentado" }}
                                        onClick={() => handleClick(referencias)}
                                        tabIndex='0'
                                    />
                                </Grid>
                            ))}
                        </Grid>
                    }
                </Alert>
            </ThemeProvider>
        </Grid>
    )
}